import React from 'react';
import Header from '../Header';
import UpgradeLicense from '../UpgradeLicense';
import upgradeLicenseImage from 'Images/ticketing-license.png';
import { Wrapper } from './styled';

// Ticketing Tools (JIRA, ServiceNow, Web Help Desk, GitLab, ServiceDesk) es Corporate-only en
// community: los 5 tabs de Menu/index.jsx renderizan este mismo componente estático -- sin
// formulario real ni requests al backend, sólo la tarjeta de upgrade.
const TicketingTools = ({ onClose }) => {
  return (
    <Wrapper>
      <Header onAccept={ onClose } onClose={ onClose } />
      <UpgradeLicense image={ upgradeLicenseImage } descriptionIntlId="upgradeLicense.ticketing.description" />
    </Wrapper>
  );
};

export default TicketingTools;
